import React from "react";

const PromotionsIcon = props => {
  const color = props.color;
  return (
    <svg width={24} height={24} {...props}>
      <path fill={color} d="M12 2l-5.5 9h11z" />
      <circle fill={color} cx={17.5} cy={17.5} r={4.5} />
      <path fill={color} d="M3 13.5h8v8H3z" />
      <path fill="none" d="M0 0h24v24H0z" />
    </svg>
  );
};
export default PromotionsIcon;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuIcons/PromotionsIcon.js